// extracted by mini-css-extract-plugin
export default {"container":"f-dropdown_container__bEiuj","btn":"f-dropdown_btn__w-R-E","wrapper":"f-dropdown_wrapper__yMPzA","drop":"f-dropdown_drop__T-i6g","drop1":"f-dropdown_drop1__pac77"};